import { cn } from '@/core/string.core';

type LoaderProps = {
  className?: string;
  fullWidth?: boolean;
};

export const Loader = ({ className, fullWidth }: LoaderProps) => {
  return (
    <div className={cn(fullWidth ? 'w-full' : 'w-12', 'h-12 flex items-center justify-center', className)}>
      <span className={cn('animated-loader', fullWidth && 'w-12')}></span>
    </div>
  );
};
